import "./App.css"
import React, { useEffect, useState } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { Grid, Stack, IconButton } from "@mui/material"
import { makeStyles, useTheme } from "@material-ui/core/styles"
import useMediaQuery from "@mui/material/useMediaQuery"
import { ThemeProvider } from "@material-ui/core/styles"

// screens import
import Home from "./screens/Home"
import About from "./screens/About"
import Projects from "./screens/Projects"
import Contact from "./screens/Contact"
import Resume from "./screens/Resume"
import TransitionScreen from "./screens/TransitionScreen"

// Components import
import Sidebar from "./components/Sidebar"
// import {lightTheme, darkTheme} from './components/theme'
import ModernSidebarContainer from "./containers/ModernSidebarContainer"
import Socials from "./components/Socials"
import { Paper } from "@material-ui/core"
import TopbarContainer from "./containers/TopbarContainer"

const useStyles = makeStyles((theme) => ({
	side: {
		position: "fixed",
		right: "0px",
		top: "35%",
		[theme.breakpoints.down("sm")]: {
			position: "relative"
		}
	},
	container: {
		margin: "0px",
		marginTop: "55px",
		background: theme.palette.background.main
	},
	transitionScreen: {
		// display: "none",
		opacity: "0",
		height: "0vh",
		width: "100vw",
		transition: "all 500ms ease",
	},
	transitioningScreen: {
		width: "100vw",
		height: "100vh",
		backgroundColor: theme.palette.background.main,
		position: "absolute",
		zIndex: 3,
		display: "flex",
		opacity: "1",
		transition: "opacity 10ms height 1000ms ease",
	}
}))

function App() {
	const theme = useTheme()
	const classes = useStyles()
	const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
	const [isTranstioning, setIsTranstioning] = useState(false)
	// const [darkMode, setDarkMode] = useState(true)

	useEffect(() => {
		const callToBackend = async () => {
			const response = await fetch(
				"https://portfolio-backend-kmgi.onrender.com/api/"
			)
			const data = await response.json()
			console.log(data)
		}

		setInterval(() => {
			callToBackend()
		}, 1000 * 60 * 5)
	}, [])

	const handleTransition = (x) => {
		setIsTranstioning(x)
	}

	return (
		// <ThemeProvider theme={darkMode?darkTheme:lightTheme}>
		<div className={classes.masterContainer}>
			<TransitionScreen isChange={isTranstioning} />
			<TopbarContainer />
			<div className={classes.container}>
				{/* <Topbar /> */}
				<div
					style={{
						position: "fixed",
						bottom: isMobile ? "40%" : 25,
						left: isMobile ? 5 : 15,
						cursor: "pointer"
					}}
				>
					<Socials />
				</div>
				<Grid
					container
					direction={isMobile ? "column-reverse" : "row"}
					style={{ height: "100%" }}
				>
					<Grid
						item
						xs={12}
						justifyContent="center"
						alignItems="center"
						style={{ height: "100vh" }}
					>
						{/* <Router> */}

						<Routes>
							<Route path="/resume" element={<Resume />} />
							<Route path="/about" element={<About />} />
							<Route path="/projects" element={<Projects />} />
							<Route path="/contact" element={<Contact />} />
							<Route path="/" element={<Home />} />
						</Routes>

						{/* </Router> */}
						<div className={classes.side}>
							<ModernSidebarContainer handleTransition = {handleTransition} />
						</div>
					</Grid>
					{/* <Grid item sm={2} className={classes.side}>
        <Sidebar />
      </Grid> */}
				</Grid>
			</div>
		</div>
		// </ThemeProvider>
	)
}

export default App
